import { Link, useNavigate } from "react-router-dom";
import { Alert, Button, Col, Row, Spinner } from "react-bootstrap";
import { useQuery } from "react-query";
import Icon from "@mdi/react";
import { mdiCardRemoveOutline, mdiChevronRight, mdiCogOutline, mdiFileDocumentOutline } from "@mdi/js";

import { SkeletonCount } from "src/config/defines";
import { useToast } from "src/context/ToastContext";
import { CriteriaEntityGetResponse } from "src/entities/CriteriaEntity";
import CriteriaService, { criteriaQueryKeys } from "src/services/CriteriaService";

import CriterioCard from "src/components/CriterioCard";
import Layout from "src/components/Layout";

const criteriaService = new CriteriaService();

export default function ConfiguracoesCriterios() {
	const navigate = useNavigate();
	
	useToast("Critérios");

	const {
		data,
		isLoading,
		isRefetching,
		isError,
	} = useQuery<CriteriaEntityGetResponse[]>(
		criteriaQueryKeys.list, 
		() => fetchData(),
		{ refetchOnWindowFocus: false }
	);

	async function fetchData() {
		const resp = await criteriaService.getCriteria();
		return resp.data.items;
	}

	return (
		<Layout>
			<h5 className="mt-4 mb-4 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3 fw-light">
				<div className="d-flex align-items-center flex-wrap">
					<Link to={"/configuracoes"} className="d-flex text-decoration-none">
						<Icon path={mdiCogOutline} size={1} className="me-1" /> Configurações
					</Link>
					<Icon path={mdiChevronRight} size={1} className="ms-1 me-1" />
					<Icon path={mdiFileDocumentOutline} size={1} className="me-1" /> Critérios
				</div>
				{isRefetching && <Spinner size="sm" className="ms-1" variant="secondary" />}
				<div className="ms-sm-auto">
					<Button
						variant="primary"
						className="rounded-3 shadow-sm"
						onClick={() => {
							navigate("/criterioFormulario");
						}}
					>
						Cadastrar
					</Button>
				</div>
			</h5>

			<Row className="mb-4">
				{isLoading &&
					Array.from({ length: Number(SkeletonCount) }, (_, index) => {
						return (
							<Col md={12} key={index}>
								<CriterioCard skeleton />
							</Col>
						);
					})}
				{!isLoading && isError && (
					<Col md={12}>
						<Alert variant="secondary" className="text-center">
							Problema na operação. Tente novamente mais tarde
						</Alert>
					</Col>
				)}
				{!isLoading && data && data.length === 0 && (
					<Col md={12}>
						<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
							<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
							Nenhum registro encontrado
						</Alert>
					</Col>
				)}
				{(!isLoading && data && data.length >= 1) && data.map((item, index) => {
					return (
						<Col md={12} key={index}>
							<CriterioCard data={item} />
						</Col>
					);
				})}
			</Row>
		</Layout>
	);
}
